import { Avatar, Box, Chip, CircularProgress, Typography } from '@mui/material'
import SimpleTable from 'common/components/SimpleTable'

const getProgressColor = (value) => {
  if (value >= 75) return 'success'
  if (value >= 33) return 'warning'
  return 'error'
}

const getEstadoChip = (p_evaluacion) => {
  if (p_evaluacion >= 100) return { label: 'Completada', color: 'success' }
  if (p_evaluacion > 0) return { label: 'En progreso', color: 'primary' }
  return { label: 'Sin iniciar', color: 'default' }
}

const EvaluadoresTable = ({ evaluadores, loading, onEvaluadorClick }) => {
  const fields = [
    {
      field: 'nombre',
      title: 'Nombre',
      customGetter: (item) => {
        const [apellidos = '', nombre = ''] = (item?.nombre ?? '').split(', ')
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Avatar src={`/assets/images/${item?.imagen}`} sx={{ width: 60, height: 60 }} />
            <Box>
              <Typography variant="body2" fontWeight="bold">
                {apellidos}
              </Typography>
              <Typography
                variant="caption"
                sx={{ textTransform: 'uppercase', letterSpacing: 1, color: 'text.secondary' }}
              >
                {nombre}
              </Typography>
            </Box>
          </Box>
        )
      },
    },
    {
      field: 'puestos',
      title: 'Puesto',
      customGetter: (item) => item?.puestos?.[0]?.descripcion ?? '—',
    },
    {
      field: 'estado',
      title: 'Estado',
      headerStyle: { width: '120px', textAlign: 'center' },
      cellStyle: { textAlign: 'center' },
      customGetter: (item) => {
        const { label, color } = getEstadoChip(item.p_evaluacion || 0)
        return <Chip label={label} color={color} size="small" />
      },
    },
    {
      field: 'p_evaluacion',
      title: 'Progreso',
      headerStyle: { width: '90px', textAlign: 'center' },
      cellStyle: { textAlign: 'center' },
      customGetter: (item) => {
        const porcentaje = item.p_evaluacion || 0
        const progressColor = getProgressColor(porcentaje)
        return (
          <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress
              variant="determinate"
              value={porcentaje}
              color={progressColor}
              size={48}
              thickness={5}
            />
            <Box
              sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography variant="caption" fontWeight="bold" color={`${progressColor}.main`}>
                {`${Math.round(porcentaje)}%`}
              </Typography>
            </Box>
          </Box>
        )
      },
    },
  ]

  return (
    <SimpleTable
      loading={loading}
      dataSource={evaluadores || []}
      onRowClick={({ row }) => onEvaluadorClick(row)}
      fields={fields}
      stripped={true}
      emptyText="No hay evaluadores disponibles."
    />
  )
}

export default EvaluadoresTable
